import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    class: "tw-inline-flex tw-items-center tw-gap-1"
};
const _hoisted_2 = {
    key: 0,
    class: "tw-text-sf-gray-light tw-text-xs tw-leading-[1] tw-uppercase"
};
const _hoisted_3 = {
    class: "tw-text-sf-gray tw-text-sm tw-leading-[1.4] tw-font-medium"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'subsidiary-name-cell',
    props: {
        accountName: {
            default: ' '
        },
        subsidiaryName: {
            default: ' '
        }
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("span", _hoisted_1, [
                _ctx.subsidiaryName ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.subsidiaryName), 1)) : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.accountName), 1)
            ]);
        };
    }
});
